import { NgModule } from '@angular/core';
import { NgxSpinnerModule } from 'ngx-spinner';

import { InfoRoutingModule } from './info-routing.module';
import { HelpPageComponent } from './help-page/help-page.component';


@NgModule({
  imports: [
    InfoRoutingModule,
    NgxSpinnerModule    
  ],
  declarations: [
    HelpPageComponent]
})
export class InfoModule { }



// WEBPACK FOOTER //
// ./src/app/modules/help/components/info.module.ts